var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"ad",staticClass:"ad-slot",class:_vm.classes,attrs:{"id":_vm.id,"data-test-id":_vm.testId}})}
var staticRenderFns = []

export { render, staticRenderFns }